module.exports = __webpack_public_path__ + "img/banner.fc7e6547.png";